import { useSocket } from '@context/SocketContext'
import { useEffect } from 'react'

/**
 * Holds the trip's realtime room while the calling surface is mounted. Rooms are counted
 * per surface, so one surface letting go never drops another's, and a reconnect rejoins
 * whatever is still held.
 */
export const useTripRoom = (tripId: string | undefined): void => {
	const { joinTrip, leaveTrip } = useSocket()

	useEffect(() => {
		if (!tripId) return
		joinTrip(tripId)
		return () => leaveTrip(tripId)
	}, [tripId, joinTrip, leaveTrip])
}
